// Go and Stop operate on one narrated demonstration. Audio stays on Flink's
// existing shared player; this coordinator never creates a second sound channel.
export function createNarratedDemoTransport({state,startFrames,pauseFrames,playNarration,pauseNarration,resetNarration,changed=()=>{}}) {
 let narrationFinished=false;
 return {
  play({force=false}={}) {
   const current=state();
   if(!current.hasDemo||current.playing||current.narrationPlaying||(!force&&current.locked))return false;
   // A completed demonstration replays from its beginning. A paused one keeps
   // both its saved frame elapsed time and the audio player's retained seek.
   if(!current.elapsed){resetNarration();narrationFinished=false;}
   if(current.hasAudio&&!narrationFinished)playNarration();
   startFrames();changed();return true;
  },
  pause(){pauseFrames();pauseNarration();changed();},
  toggle(){const current=state();if(current.playing||current.narrationPlaying){this.pause();return true;}return this.play();},
  audioEnded(){narrationFinished=true;},
  reset(){narrationFinished=false;},
 };
}

// While narrated audio is loading or playing, its seek position is the clock.
// Re-anchor the wall clock on every tick so a load delay or pause cannot make
// frames race ahead. If speech ends early/fails, remaining frames continue.
export function advanceDemoClock({now,started,scale=1,frameDuration,audio=null}) {
 const narrated=audio!==null;
 const elapsed=narrated?Math.max(0,Number(audio.currentTime)||0)*1000:Math.max(0,now-started);
 const nextScale=frameDuration>0&&narrated?Math.max(scale,(Number(audio.duration)||0)*1000/frameDuration):scale;
 return {elapsed,started:narrated?now-elapsed:started,scale:nextScale,frameTime:elapsed/nextScale};
}
